{
  "aboutDeviceControls": "Acerca de los controles del dispositivo",
  "actionLabel": "Acción: ",
  "adminUser": "Usuario administrador",
  "automation": "Automatización",
  "command": "Dominio",
  "conditionLabel": "Condición: ",
  "confirmDeviceActionCannotCancelWarning": "Esta acción no se puede cancelar.",
  "confirmDeviceActionIAcceptText": "Acepto la responsabilidad por el resultado de esta acción.",
  "confirmDeviceActionSuccessToast": "Solicitud enviada al dispositivo",
  "confirmDeviceActionSuccessToastWithDeviceName": "Solicitud enviada al dispositivo {{deviceName}}",
  "confirmDeviceActionWarningDescription": "Controlar un circuito manualmente puede tener consecuencias peligrosas. Al realizar esta acción, usted acepta toda la responsabilidad por cualquier daño o perjuicio que pueda resultar.",
  "confirmationRequired": "Se requiere confirmación",
  "controlPanelHelpContent": "Puede enviar comandos para controlar directamente el interruptor (también conocido como relé) en su dispositivo. Estos comandos pueden tener diferentes efectos según la forma en que haya instalado su dispositivo y el tipo de instalación de su equipo.\n\nPara utilizar estos controles, debe tener permiso para controlar dispositivos de forma remota. Si es administrador de su granja, puede denegar o conceder acceso a estas funciones desde la configuración de la cuenta.",
  "controls": "Controles",
  "deviceActionHistoryListEmpty": "No se encontró historial de comandos para este dispositivo",
  "deviceActionHistoryListTitle": "Historial de acciones",
  "deviceActionHistoryListHelpBodyText": "Muestra las acciones anteriores realizadas en un dispositivo. Esta lista incluye acciones automatizadas realizadas por FarmHQ, así como acciones manuales realizadas por los usuarios.",
  "deviceControls": "Controles del dispositivo",
  "result": "Resultado",
  "system": "Sistema",
  "time": "Tiempo",
  "triggeredBy": "Activado por",
  "turnWaterOff": "Cierra el agua",
  "turnWaterOn": "Abra el agua",
  "unknownAction": "Acción desconocida",
  "warning": "Advertencia"
}
